module.exports = __webpack_public_path__ + "img/copy-grey.256780b0.svg";